// ------------------------------------
// Constants
// ------------------------------------
export const SET_GEOPOSITION = 'SET_GEOPOSITION'
export const SET_WATCHER = 'SET_WATCHER'

// ------------------------------------
// Actions
// ------------------------------------
export function setGeoposition (geoposition = null) {
  return {
    type    : SET_GEOPOSITION,
    payload : geoposition
  }
}

export function setWatcher (watcher = null) {
  return {
    type    : SET_WATCHER,
    payload : watcher
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
let initialState = {
  position: null,
  watcher: null
}
export function geopositionReducer (state = initialState, action) {
  switch (action.type) {
    case SET_GEOPOSITION:
      return { position: action.payload, watcher: state.watcher }
    case SET_WATCHER:
      return { position: state.position, watcher: action.payload }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/geoposition.js